import * as types from "./actionTypes";

export function started() {
	return {
		type: types.AJAX_CALL_STARTED
	};
}

export function ended() {
	return {
		type: types.AJAX_CALL_ENDED
	};
}

export function failed() {
	return {
		type: types.AJAX_CALL_FAILED
	};
}

